import { render, staticRenderFns } from "./ViewsView.vue?vue&type=template&id=7c547bce&scoped=true"
import script from "./ViewsView.vue?vue&type=script&lang=ts"
export * from "./ViewsView.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c547bce",
  null
  
)

export default component.exports